export namespace GasRange {
  export type TypeMode = number | string | Date;

  export enum ModeEnum {
    Numeric = 'numeric',
    Date = 'date',
  }

  export interface DateParams {
    mask: string;
    value: string | Date | number;
  }

  export const MODES: Record<string, ModeInterface> = {
    [ModeEnum.Numeric]: {
      compareFunction: compareNumericValues,
      convertFunction: convertToNumber,
      calcSmallestValue: calcSmallestNumericValue,
      calcLargestValue: calcLargestNumericValue,
      checkBoundaryValues,
    },
    [ModeEnum.Date]: {
      compareFunction: compareDateValues,
      convertFunction: convertDatestringToNumber,
      calcSmallestValue: calcSmallestDateValue,
      calcLargestValue: calcLargestDateValue,
      checkBoundaryValues,
    },
  };

  export interface ModeInterface {
    compareFunction: (a: TypeMode, b: TypeMode) => boolean;
    convertFunction: (value: TypeMode) => number;
    calcSmallestValue: (value: TypeMode) => number;
    calcLargestValue: (value: TypeMode) => number;
    checkBoundaryValues: (smallestValue: number, largestValue: number, value: number) => boolean;
  }

  // TODO: Написать тесты на функции ниже

  /** Функции обработка чисел */
  export function compareNumericValues(a: number, b: number): boolean {
    return a < b;
  }

  export function convertToNumber(value: number): number {
    return Number(value);
  }

  export function calcSmallestNumericValue(value?: number): number {
    return value
      ? Number(value)
      : Number.MIN_SAFE_INTEGER;
  }

  export function calcLargestNumericValue(value?: number): number {
    return value
      ? Number(value)
      : Number.MAX_SAFE_INTEGER;
  }

  /** Функции обработки дат */
  export function compareDateValues(a: string | Date, b: string | Date): boolean {
    return convertDatestringToNumber(a) <= convertDatestringToNumber(b);
  }

  export function convertDatestringToNumber(dateString: string | Date): number {
    let formattedDateString = dateString.toString();
    if (dateString instanceof Date) {
      formattedDateString = dateString.toLocaleDateString('ru');
    }
    const dateTimeArray = formattedDateString.split(' ');
    let dateNumber = dateTimeArray[0].split('.').reverse().join('');

    if (!!dateTimeArray[1]) {
      dateNumber = dateNumber + dateTimeArray[1].replace(':', '');
    }

    return +dateNumber;
  }

  export function calcSmallestDateValue(value?: string | Date): number {
    return value ? convertDatestringToNumber(value.toString()) : 0;
  }

  export function calcLargestDateValue(value?: string | Date): number {
    return value ? convertDatestringToNumber(value.toString()) : Number.MAX_SAFE_INTEGER;
  }

  /** Общие функции обработки значений */
  export function checkBoundaryValues(
    smallestValue: number,
    largestValue: number,
    value: number,
  ): boolean {
    return !( ( value < smallestValue ) || ( value > largestValue ) );
  }

  /** Метод проверки корректного значения value для работы с датами */
  export function checkDateInputsValue(firstDate: DateParams, secondDate: DateParams): boolean {
    /** проверяем что оба значения введены */
    if (firstDate.value && secondDate.value) {
      /** если оба контролла date-object возвращаем true */
      if (typeof firstDate.value === 'object' && typeof secondDate.value === 'object') {
        return true;
      }

      /** если в контроллах строки, то проверку на min и max можно делать только когда даты введены полностью */
      if (typeof firstDate.value === 'string' && typeof secondDate.value === 'string') {
        if (( firstDate.value as string ).length !== firstDate.mask?.length) {
          return false;
        }
        if (( secondDate.value as string ).length !== secondDate.mask?.length) {
          return false;
        }

        return true;
      }

      /** если по какой-то причине один из контроллов пришел number возвращаем false */
      if (typeof firstDate.value === 'number' || typeof secondDate.value === 'number') {
        return false;
      }
    }

    /** если в первом контроле стринга, проверяем что данные введены полностью */
    if (firstDate.value && typeof firstDate.value === 'string') {
      return ( firstDate.value as string ).length === firstDate.mask?.length;
    }

    /** если во втором контроле стринга, проверяем что данные введены полностью */
    if (secondDate.value && typeof secondDate.value === 'string') {
      return ( secondDate.value as string ).length === secondDate.mask?.length;
    }

    return true;
  }
}
